import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps, Carrier } from 'src/Library/Types';
import { connect } from 'react-redux';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { buttonStyle } from 'src/Library/CommonStyles';
import { arrayToObject } from 'src/utils/utils';
import { nl2Br } from 'src/utils/DOMUtils';

const styles = (theme) => ({
  modal: {
    '& .ant-modal-header': {
      borderBottom: '1px solid rgba(225, 225, 225, 0.2)',
    },
    '& .ant-modal-body': {
      padding: '16px 24px 40px 24px',
      color: '#666666',
      lineHeight: '22px',
    },
    '& .ant-modal-footer': {
      borderTop: '1px solid rgba(225, 225, 225, 0.2)',
    },
  },
  declineButton: {
    color: '#666666',
    cursor: 'pointer',
  },
  acceptButton: {
    ...buttonStyle('#FFFFFF', '#006EC3', '1px solid #006EC3'),
    borderRadius: '2px',
    marginLeft: '14px',
    padding: '0 22px',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  isVisible: boolean;
  onDecline: () => void;
  onAccept: () => void;
  bookingTermsAndConditions: string;
  shippingLines: Carrier [];
  carrierCode: string;
}

const BookingTnCModal = (props: IProps): React.ReactElement => {

  const {
    isVisible,
    classes,
    onDecline,
    onAccept,
    bookingTermsAndConditions,
    shippingLines,
    carrierCode,
  } = props;

  const getTextFromHtml = () => {
    const carrierMap = arrayToObject(shippingLines, 'id');
    const carrierTermsAndConditions = carrierMap[carrierCode]?.termsAndConditions;
    const termsAndConditions = `${carrierTermsAndConditions ?
      `${bookingTermsAndConditions}\r\n${carrierTermsAndConditions}` : bookingTermsAndConditions}`;
    return nl2Br(termsAndConditions, '\r\n', true, { marginTop: '12px', display: 'flex' });
  }

  return (
    <Modal
      visible={isVisible}
      zIndex={1000}
      width={450}
      className={classes.modal}
      title="Terms & Conditions"
      onCancel={onDecline}
      footer={
        <React.Fragment>
          <span className={classes.declineButton}
            onClick={onDecline}>Decline</span>
          <Button className={classes.acceptButton}
            onClick={onAccept}>Accept</Button>
        </React.Fragment>
      }
    >
      {getTextFromHtml()}
    </Modal>
  );
};

const mapStateToProps = ({ masterData }, ownProps) => ({
  bookingTermsAndConditions: masterData.bookingTermsAndConditions,
  shippingLines: masterData.globalShippingLines,
});

export default connect(
  mapStateToProps,
  null,
)(withStyles(styles)(React.memo(BookingTnCModal)));
